import { IS_DEV } from '../config-global';

export function getShopIdFromPathname(strPathname) {
    const patterns = [
        // Пути, где shopid идёт сразу после префикса
        /^\/(?:shop|lp|event|games|product)\/([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,

        // Пути, где shopid идёт после dashboard/...
        /^\/dashboard\/(?:shop|shops|stories|usercard|general|pages|orders|analytics|notify|subscribers|referals|forms|forms2|quizzes|integrations|settings|pays)\/([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,

        // Пути, где shopid идёт после dashboard/general/...
        /^\/dashboard\/general\/(?:shop|usercard|usercardchoice|settings|articles|tools|qs|chatbot|goods|pages|payment|paymentManual|promotions|affiliate|paymentAuto)\/([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,

        // Пути, где shopid идёт после dashboard/notify/...
        /^\/dashboard\/notify\/(?:auto\/element\/)?([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,

        // Пути, где shopid идёт после product/...
        /^\/product\/(?:shop|article)\/([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,

        // Специфический путь dashboard/notify/.../list/
        /^\/dashboard\/notify\/([a-zA-Z0-9-]{15,}|main)\/list\//,

        // /dashboard/forms/answer_comments/...
        /^\/dashboard\/forms\/answer_comments\/([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,

        // /profile/forms/answer_comments/...
        /^\/profile\/forms\/answer_comments\/([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,
        /^\/dashboard\/forms\/new_edit\/([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,

        // Student routes
        /^\/student\/([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,

        // New Dashboard routes with shopid
        /^\/dashboard\/([a-zA-Z0-9-]{15,}|main)(?:\/|\?|$)/,
    ];

    let shopId = "";
    patterns.forEach((pattern) => {
        const match = strPathname.match(pattern);
        if (match && !shopId) {
            shopId = match[1];
            if (IS_DEV) {
                console.log(`Extracted shopId from pathname "${strPathname}":`, shopId);
            }
        }
    });

    // if (!shopId && process.env.NODE_ENV === 'development') {
    //     console.log(`No shopId found in pathname "${strPathname}"`);
    // }

    return shopId;
}
